<template>
    <router-view></router-view>
</template>
<script>
    export default {
        name:'AuthLayout', 
        
        data() {
            return {
               
            }
        },
       
       
    }
</script>
<style scoped>
</style>

